module.exports = __webpack_public_path__ + "media/images/layout/landing_pages-bf8b21bbc8da6afa26ea430407706fd6.svg";